<template>
    <div class="py-4 px-8 bgray-200 d-flex align-item-center justify-content-between">
        <div class="d-flex align-item-center">
            <b-img src="@/assets/QuantifiedESG_Logo_v3_Basic.svg" style="width: 110px;"></b-img>
        </div>
        <a class="gray-600 f-90" href="http://tierzero.kr/" target="_blank"> tierzero.kr </a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },

}
</script>

<style>
.py-45{
    padding-top: 2.1rem!important;
    padding-bottom: 2.1rem!important;
}
</style>